import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Container,
  Textbox,
  OperacionesControl,
  TipoControl,
  TextArea
} from '@app/shared';


@Injectable()
export class CreationOperactionFormsService {
  constructor() { }

  /**
   * Genera el formulario para agregar una operacion a el control dependiendo de su tipo
   *
   * @param {OperacionesControl} operation
   * @param {TipoControl} typeControl
   * @returns {BaseControl<any>[]}
   * @memberof CreationOperactionFormsService
   */
  getOperaction(operation: OperacionesControl, typeControl: TipoControl): BaseControl<any>[] {
    let messageHelp = 'También es válido ingresar solo la referencia de un valor como por ejemplo solo "a".';
    let messagePlaceholder = 'Ingrese la operacion a realizar con las referencias de los valores ' +
                             'como por ejemplo: "a + b".';
    if (typeControl.nombre === 'text' || typeControl.nombre === 'textarea') {
      messagePlaceholder = 'Ingrese el texto y las referencias de los valores que se desean reemplazar.';
      messageHelp = 'Ingrese las referencias dentro de los siguientes signos {}, por ejemplo: "{ref}".';
    } else if (typeControl.nombre === 'date-time-picker') {
      messagePlaceholder = 'Ingrese el método a ejecutar con sus argumentos como por ejemplo ' +
                           '"sumarDias(fecha, operacion)".';
      messageHelp = 'Para operar con fechas es necesario utilizar los métodos reservados y dentro de los ' +
                    'paréntesis de dichos métodos ir como primer argumento la fecha y como segundo ' +
                    'argumento la operación.';
    } else if (
      typeControl.nombre === 'ngSelect' ||
      typeControl.nombre === 'email' ||
      typeControl.nombre === 'checkbox'
    ) {
      messagePlaceholder = 'Para este tipo de campos solo se permite una referencia.';
      messageHelp = 'Para este tipo de campos solo se permite una referencia, que ya esta ingresada por defecto.';
    }

    let control: BaseControl<any> = new Textbox({
      key: 'txtOperacion',
      label: 'Campo:',
      value: operation ? operation.operacion : null,
      size: 'col-md-12',
      placeholder: messagePlaceholder,
      describe: messageHelp,
      validations: {
        validators: [Validators.required]
      }
    });

    if (typeControl.nombre === 'textarea') {
      control = new TextArea({
        key: 'txtOperacion',
        label: 'Campo:',
        value: operation ? operation.operacion : null,
        size: 'col-md-12',
        rows: '3',
        placeholder: messagePlaceholder,
        describe: messageHelp,
        validations: {
          validators: [Validators.required]
        }
      });
    } else if (
      typeControl.nombre === 'ngSelect' ||
      typeControl.nombre === 'email' ||
      typeControl.nombre === 'checkbox'
    ) {
      control = new Textbox({
        key: 'txtOperacion',
        label: 'Campo:',
        value: operation ? operation.operacion : 'valor',
        size: 'col-md-12',
        placeholder: messagePlaceholder,
        describe: messageHelp,
        disabled: true,
        validations: {
          validators: [Validators.required]
        }
      });
    }

    const controls: BaseControl<any>[] = [new Container({
        class: 'form-row form-check form-check-inline border mb-2 col-12',
        order: 1,
        controls: [
          control,
          control = new Textbox({
            key: 'chkEjecutar',
            label: 'Ejecutar siempre',
            type: 'checkbox',
            order: 2,
            value: operation ? operation.ejecutar_siempre : false,
            size: 'col-md-12'
          })
        ]
      })
    ];
    return controls;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/operations-form/creation-operation/shared/creation-operation.forms.service.ts